<template>
  <v-row>
    <v-col cols="3">
      <metric-kpi metric="total_cancelled_subscription" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="3">
      <metric-kpi metric="rate_cancelled_subscription" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="3">
      <metric-kpi :metric="metrics.arp" interval="monthly" comparative="this_v_last" />
    </v-col>

    <!-- MRR / ARR toggle -->
    <v-col cols="12" class="px-0 pb-0">
      <v-toolbar color="transparent" flat height="55" dense>
        <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">
          <template v-if="mode === 'mrr'">Ingresos recurrentes mensuales (MRR)</template>
          <template v-else>Ingresos recurrentes anuales (ARR)</template>
        </v-toolbar-title>
        <v-spacer />
        <v-btn-toggle v-model="mode" background-color="primary" color="primary" dark mandatory>
          <v-btn value="mrr" outlined>Visualizar MRR</v-btn>
          <v-btn value="arr" outlined>Visualizar ARR</v-btn>
        </v-btn-toggle>
      </v-toolbar>
    </v-col>
    <v-col cols="6" class="py-0">
      <v-row>
        <v-col cols="6">
          <metric-kpi :metric="metrics.total" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="6">
          <metric-kpi :metric="metrics.netGrowth" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="6">
          <metric-kpi :metric="metrics.new" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="6">
          <metric-kpi :metric="metrics.expansion" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="6">
          <metric-kpi :metric="metrics.contraction" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="6">
          <metric-kpi :metric="metrics.churn" interval="monthly" comparative="this_v_last" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6">
      <metric-graph :metric="metrics.netGrowth" />
    </v-col>
  </v-row>
</template>
<script>
import MetricKpi from '@/components/reports/MetricKpi'
import MetricGraph from '@/components/reports/MetricGraph'

const METRICS_BY_MODE = {
  mrr: {
    total: 'total_mrr',
    new: 'new_mrr',
    expansion: 'expansion_mrr',
    contraction: 'contraction_mrr',
    churn: 'churn_mrr',
    netGrowth: 'net_growth_mrr',
    arp: 'arpu'
  },
  arr: {
    total: 'total_arr',
    new: 'new_arr',
    expansion: 'expansion_arr',
    contraction: 'contraction_arr',
    churn: 'churn_arr',
    netGrowth: 'net_growth_arr',
    arp: 'arpa'
  }
}

export default {
  components: {
    MetricKpi,
    MetricGraph
  },
  data: () => ({
    mode: 'mrr'
  }),
  computed: {
    metrics () {
      return METRICS_BY_MODE[this.mode]
    }
  }
}
</script>
